var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Table',{attrs:{"fields":_vm.tableFields,"items":_vm.items}})
}
var staticRenderFns = []

export { render, staticRenderFns }